export default "__VITE_ASSET__Dn1ZcIqu__"